module.exports = __webpack_public_path__ + "assets/img/season-code-03-17c732a1.png";